module.exports = __webpack_public_path__ + "static/media/mySvg.257c1b52.svg";